(function (namespace, $) {
        "use strict";

        var AppAlert = function () {
            // Create reference to this instance
            var o = this;
            // Initialize app when document is ready
            $(document).ready(function () {
                o.initialize();
            });

        };

        var p = AppAlert.prototype;
        p.card = window.gpssat.AppCard;
        p.alerts = window.gpssat.AppMessage;
        p.app = window.gpssat.App;
        p._numberAlerts = null;
        p._getNumber = true;

        p.initialize = function () {
            var o = this;
            o._getNumberAlerts();
            o._enableEvents();

            setInterval(function () {
                o._getNumberAlerts();
            }, 30000);
        };

        p._enableEvents = function () {
            var o = this;
            jQuery('#button-alert-menu').on('click', function (e) {
                e.preventDefault();
                o._getAlerts(this);

            });

            jQuery(document).on('click', '#answer-alert', function (e) {
                if (jQuery(this).attr('disabled') != 'disabled') {
                    o._answer(jQuery(this).attr('data-id'));
                }
            });
        };

        p._getAlerts = function ($this) {
            var o = this;

            o._getNumber = true;
            o.app._ajax('GET', window.location.origin + "/alerts", false,
                function (data) {
                    jQuery('#offcanvas-alert-left .offcanvas-body').html('');

                    var html, color, icon;
                    for (var i in data) {

                        switch (data[i].identification) {
                            case 'operation'    :
                                icon = 'fa fa-tree';
                                break;
                            case 'operational'  :
                                icon = 'fa fa-tree';
                                break;
                            case 'maintenance'  :
                                icon = 'fa fa-wrench';
                                break;
                            case 'sos'          :
                                icon = 'fa fa-exclamation-triangle';
                                break;
                            default             :
                                icon = 'md md-local-gas-station';
                                break;
                        }
                        switch (data[i].level) {
                            case 3:
                                color = 'info';
                                break;
                            case 2:
                                color = 'warning';
                                break;
                            default:
                                color = 'error';
                                break;
                        }

                        var margin = (data[i].ids.length > 9) ? '16px' : '12px';

                        html = '<div class="alert alert-callout alert-' + color + '">';
                        html += '<div class="col-md-2" style="font-size: 45px; margin-right: 15px !important; margin-top:15px; height: 120px;">';
                        html += '<span id="badge' + data[i].vehicle_id + '" style="font-size:16px"><sup class="badge style-danger" style="position:absolute; top:8px; left:16px; border-radius:4px">' + data[i].ids.length + '</sup></span>';
                        html += '<i class="' + icon + '" style="display: inline"></i></div>';
                        html += '<a href="javascript:void(0)" title="Atender alerta" data-id="' + data[i].ids.join(',') + '" id="answer-alert" data-loading-text="<i class=\'pull-right fa fa-spinner fa-spin\'></i>">';
                        html += '<i class="pull-right md md-check-box" style="margin-right: ' + margin + '"></i>';
                        html += '</a>';
                        html += '<strong style="font-size:18px;">' + data[i].vehicle + '</strong>';
                        html += '<small  style="font-size:12px;"> &nbsp; &nbsp; <i>' + data[i].date.replace('<br>', '') + '</i></small><br/>';
                        html += '<small  style="font-size:13px;">Operador: ' + (data[i].operator ? data[i].operator : '--') + '</small>';
                        html += '<a href="javascript:void(0)" title="Enviar mensagem" data-id="' + data[i].vehicle_id + '" id="open-chat"data-loading-text="<i class=\'pull-right fa fa-spinner fa-spin\'></i>">';
                        html += '<i class="pull-right md md-email" style="margin-right: ' + margin + '"></i>';
                        html += '</a><br/>';
                        html += '<small  style="font-size:14px;"><b>' + data[i].description + '</b></small>';
                        html += '<a href="javascript:void(0)" title="Histórico" data-id="' + data[i].vehicle_id + '" id="historic-chat" data-dismiss="offcanvas">';
                        html += '<i class="pull-right md md-history" style="margin-right: ' + margin + '"></i></a><br/>';
                        html += '<small  style="font-size:12px;">' + (data[i].event_details ? data[i].event_details : '') + '</small><br/>';

                        html += '</div>';
                        jQuery('#offcanvas-alert-left .offcanvas-body').append(html);
                    }
                    window.gpssat.AppOffcanvas._handleOffcanvasOpen(jQuery(this).attr('href', '#offcanvas-alert-left'));
                },
                function (data) {
                    o.alerts._error(Lang.get('error-support'));
                }
            );
        };

        p._answer = function (id) {
            var o = this;

            var btn = jQuery("[data-id='" + id + "']");
            btn.attr("disabled", true);
            btn.button('loading');
            o.card.addCardLoader(jQuery('#offcanvas-alert-left'));
            o.app._ajax('POST', window.location.origin + "/alerts/answer", {ids: id.split(',')},
                function (data) {
                    btn.parent().hide('slow', function () {
                        btn.parent().remove();
                    });
                    o._getNumber = true;
                    o._getNumberAlerts();
                    o.card.removeCardLoader(jQuery('#offcanvas-alert-left'));
                },
                function (data) {
                    btn.button('reset');
                    btn.attr("disabled", false);
                    o.alerts._error(data.responseText);
                    o.card.removeCardLoader(jQuery('#offcanvas-alert-left'));
                },
                false
            );
        };

        p._getNumberAlerts = function () {
            var o = this;

            if (o._getNumber) {
                o.app._ajax('GET', window.location.origin + "/alerts/number", false,
                    function (data) {
                        let messages = data.messages;
                        let alerts = data.alerts;
                        let oldNumber = o._numberAlerts;

                        o._numberAlerts = parseInt(alerts);

                        if (o._numberAlerts > 0) {

                            if (oldNumber !== null && oldNumber < o._numberAlerts) {
                                Push.create('Sistema de Monitoramento', {
                                    body: 'Você recebeu ' + (o._numberAlerts - oldNumber) + ' alerta(s) novo(s).',
                                    icon: {
                                        x16: '/img/alert_icon-x16.png',
                                        x32: '/img/alert_icon-x32.png'
                                    },
                                    timeout: 10000
                                });
                            }

                            if ($('#events-number').next('sup').length > 0) {
                                $('#events-number').next('sup').text(alerts);
                            } else {
                                $('#events-number').after('<sup class="badge style-danger">' + alerts + '</sup>');
                            }
                        } else {
                            $('#events-number').next('sup').remove();
                        }

                        if (messages > 0) {
                            if ($('#messages-number').next('sup').length > 0) {
                                $('#messages-number').next('sup').text(messages);
                            } else {
                                $('#messages-number').after('<sup class="badge style-danger">' + messages + '</sup>');
                            }
                        } else {
                            $('#messages-number').next('sup').remove()
                        }
                    },
                    function () {
                    },
                    false
                );
            }
        };

        window.gpssat.AppAlert = new AppAlert;
    }(window.gpssat, jQuery)
); // pass in (namespace, jQuery):
